// extract location without params
// redirect from legacy CRA to Astro when developing on localhost
const origin = window.location.origin;
const websiteUrl = origin === "http://localhost:3000" ? "http://localhost:4321" : origin;

// Helper function for returning redirects
function redirectToWebsite(url) {
  return () => {
    window.location.href = websiteUrl + url;
    return null;
  };
}

export { websiteUrl, redirectToWebsite };
